module.exports = __webpack_public_path__ + "static/media/report.ee464a62.svg";